import { Box } from '@mui/material'
import React from 'react'
import FallbackHeaderImageSource from '../../assets/illustrations/defaultSplash.png'
import { SlideImage } from '../../home/components/carousel/slide/SlideImage'
interface IItineraryCardProps {
    imageUrl?: string
    title?: React.ReactNode
    description?: React.ReactNode
    actions?: React.ReactNode
    onClick?: () => void
}

export const ItineraryCard = ({
    imageUrl,
    title,
    description,
    actions,
    onClick,
}: IItineraryCardProps) => {
    return (
        <SlideImage
            src={imageUrl ?? FallbackHeaderImageSource}
            noGradient
            style={{
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                borderRadius: '8px',
            }}
        >
            <Box display={'grid'} gridTemplateColumns={'1fr auto'}>
                <Box
                    display={'grid'}
                    onClick={async () => {
                        onClick?.()
                    }}
                    padding={'16px'}
                    gap={'8px'}
                >
                    {title}
                    {description}
                </Box>
                {actions}
            </Box>
        </SlideImage>
    )
}
